import React, { useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  Button,
  Row,
  Col
} from "shards-react";
import moment from "moment";
import { useFormik } from "formik";
import baseUrl from "config/baseUrl";
import ReactPaginate from "react-paginate";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import dayjs from "dayjs";
import "dayjs/locale/es";
import useToken from "shared/hook/useToken";
import Layout from "shared/container/LayoutAdmin";
import formatDateRang from "config/formatDateRang";
import {
  SelectReportsystem,
  SelectTypeUser,
  SelectIndicatorsDataset
} from "shared/components";
import { ToastContainer, toast } from "react-toastify";
import useCurrentUser from "shared/hook/useCurrentUser";

import agencyType from "shared/utils/agencyType";
import styled from "styled-components";

const axios = require("axios").default;

const StyledStatus = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : "#A3A3A3")};
  padding: 5px;
  border-radius: 6px;
  text-align: center;
  color: #fff;
`;
const AdminReport = (props) => {
  const { token } = useToken();
  const { curruntUser } = useCurrentUser();
  const [agencyTypeData, setAgencyTypeData] = useState(agencyType);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [dateReportList, setDateReportList] = useState(null);
  const [dateReportSystem, setDateReportSystem] = useState(null);
  const [reportSystemId, setReportSystemId] = useState(2);
  const [dateRange, setDateRange] = useState("");
  const [typeUserId, setTypeUserId] = useState(0);
  const [userId, setUserId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const formatDate = (date) => {
    const split = date
      .replace("T", " ")
      .replace(".000Z", "")
      .split(" ");
    return `${dayjs(split[0]).format("DD/MM/YYYY")} ${split[1]}`;
  };

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        show: 30,
        page: pageNumber,
        orderBy: "createDate",
        orderType: "DESC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/reportsystemdata`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDateReportList(response.data);
          setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [loading, pageNumber]);

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        show: 10,
        page: 1,
        orderBy: "reportSystemId",
        orderType: "desc",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/reportsystem`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDateReportSystem(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  useEffect(() => {
    if (curruntUser) {
      setUserId(curruntUser.user.userId);
    }
  }, [curruntUser]);

  const nextPage = (page, total_page) => {
    setPageNumber(page + 1);
    setTotalPage(total_page);
  };

  const getAgencyTypeName = (agencyTypeId) => {
    const list = agencyTypeData.filter(
      (item) => item.agencyTypeId === agencyTypeId
    );
    if (list.length > 0) {
      return list[0].agencyTypeName;
    } else {
      return "-";
    }
  };

  const getStatus = (status) => {
    switch (status) {
      case 1:
        return <StyledStatus bg="#7FBC46">Active</StyledStatus>;
      default:
        return <StyledStatus bg="#A3A3A3">Inactive</StyledStatus>;
    }
  };

  const getreportSystemName = (reportSystemId) => {
    if (dateReportSystem && dateReportSystem.data.length > 0) {
      const list = dateReportSystem.data.filter(
        (item) => reportSystemId === item.reportSystemId
      );
      return list.length > 0 ? list[0].reportSystemName : [];
    }
  };

  const handleDateRangePicker = (event, picker, refetch) => {
    const show = `${picker.startDate.format(
      "DD/MM/YYYY"
    )} - ${picker.endDate.format("DD/MM/YYYY")}`;
    setDateRange(show);
    setStartDate(picker.startDate.format("DD/MM/YYYY"));
    setEndDate(picker.endDate.format("DD/MM/YYYY"));
  };

  const validate = (values) => {
    const errors = {};
    if (!values.reportSystemId) {
      errors.reportSystemId = "กรุณาระบุรายงานที่ต้องการ";
    }
    if (!values.dateRange) {
      errors.dateRange = "กรุณาระบุวันที่";
    }
    if (!values.indicatorsDatasetSettingId) {
      errors.indicatorsDatasetSettingId = "กรุณาระบุข้อมูล/ตัวชี้วัด";
    }
    // if (!values.userTypeId) {
    //   errors.userTypeId = "กรุณาระบุข้อมูล/ตัวชี้วัด";
    // }
    // if (!values.userId) {
    //   errors.userId = "กรุณาระบุวันที่";
    // }

    return errors;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      reportSystemId: reportSystemId,
      indicatorsDatasetSettingId: indicatorsDatasetId,
      userTypeId: typeUserId,
      userId: userId,
      dateRange: dateRange,
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      const sendObject = {
        indicatorsDatasetSettingId: reportSystemId == 3 ? 1 : indicatorsDatasetId,
        userTypeId: typeUserId,
        userId: userId,
        reportSystemId: reportSystemId,
        dateRange: dateRange,
      };
      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/createreportsystemdata`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: sendObject,
      };

      axios(config)
        .then((response) => {
          setLoading(false);
          setReportSystemId(null);
          setDateRange(null);
          setTypeUserId(null);
          setStartDate(null);
          setEndDate(null);
          setStartDate(null);
          setIndicatorsDatasetId(null);
          resetForm();
          showNotify("แจ้งเตือน! ออกรายงานเรียบร้อย");
        })
        .catch((error) => {
          if (error.response.data.message) {
            showNotify(error.response.data.message, "error");
          } else {
            showNotify(error.message, "error");
          }
        });
    },
  });

  const getDownLoadReport = (item) => {
    let url = "logexportdataexcel";
    if (item.reportSystemId === 1) {
      url = "logactivity"
      
    } else if (item.reportSystemId === 2) {
      url = "logexportdataexcel"
      
    } else if (item.reportSystemId === 3) {
      url = "loguserexport"
      
    }

    return (
      <a
        className="btn-link"
        href={`${baseUrl}/v1/setting/${url}?day=${formatDateRang(
          item.dateRange
        )}`}
        role="button"
      >
        ดาวน์โหลด
      </a>
    );
  };

  return (
    <>
      <Layout>
        <ToastContainer />
        <Row>
          <Col md="12">
            <h6 className="bold" style={{ marginBottom: "30px" }}>
              รายงาน
            </h6>
          </Col>
        </Row>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col md="3">
              <FormGroup>
                <label>รายงานที่ต้องการ <span style={{color:'red'}}>*</span></label>
                <SelectReportsystem
                  placeholder="เลือก"
                  name="reportSystemId"
                  onChange={(e) => {
                    setReportSystemId(e.target.value);
                  }}
                  defaultValue={reportSystemId}
                  value={formik.values.reportSystemId}
                  invalid={!!formik.errors.reportSystemId}
                  typeId={formik.values.reportSystemId}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                {
                  reportSystemId == 3 ? <label>ช่วงวันที่สมัครสมาชิก <span style={{color:'red'}}>*</span></label> : <label>ช่วงวันที่ใช้งานระบบ<span style={{color:'red'}}>*</span></label>
                }
                <DateRangePicker
                  onApply={(event, picker) =>
                    handleDateRangePicker(event, picker)
                  }
                  onCancel={() => {
                    setStartDate("");
                    setEndDate("");
                    setDateRange("");
                  }}
                  initialSettings={{
                    // startDate : '15/06/2565',
                    // endDate : '20/06/2565',
                    minYear: parseInt(moment().format("YYYY")),
                    maxYear: parseInt(
                      moment()
                        .add(1, "years")
                        .format("YYYY"),
                      10
                    ),
                  }}
                >
                  <input
                    type="text"
                    value={dateRange}
                    className={`form-control ${
                      !!formik.errors.dateRange ? "is-invalid" : ""
                    }`}
                    placeholder="DD/MM/YYYY - DD/MM/YYYY"
                    onChange={(event) => {}}
                    invalid={!!formik.errors.dateRange}
                  />
                </DateRangePicker>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {reportSystemId == 1 ||
              reportSystemId == 2 ? (
                <Col md="3">
                  <FormGroup>
                    <label>ข้อมูล/ตัวชี้วัด  <span style={{color:'red'}}>*</span></label>
                    <SelectIndicatorsDataset
                      placeholder="เลือก"
                      name="indicatorsDatasetSettingId"
                      onChange={(e) => {
                        setIndicatorsDatasetId(e.target.value);
                      }}
                      defaultValue={indicatorsDatasetId}
                      value={formik.values.indicatorsDatasetSettingId}
                      invalid={!!formik.errors.indicatorsDatasetSettingId}
                      typeId={formik.values.indicatorsDatasetSettingId}
                    />
                  </FormGroup>
                </Col>
              ) : null}

            <Col md="3">
              <FormGroup>
                <label>ประเภทผู้ใช้งาน</label>
                <SelectTypeUser
                  placeholder="เลือก"
                  name="userTypeId"
                  onChange={(e) => {
                    setTypeUserId(e.target.value);
                  }}
                  defaultValue={typeUserId}
                  value={formik.values.userTypeId}
                  invalid={!!formik.errors.userTypeId}
                />
              </FormGroup>
            </Col>
            {/* <Col md="3">
              <FormGroup>
                <label>ชื่อผู้ใช้งาน</label>
                <SelectUser
                  placeholder="เลือก"
                  name="userId"
                  onChange={(e) => {
                    setUserId(e.target.value);
                  }}
                  typeId={typeUserId}
                  defaultValue={userId}
                  value={formik.values.userId}
                  invalid={!!formik.errors.userId}
                />
              </FormGroup>
            </Col> */}
            <Col md="3">
              <Button
                type="submit"
                className="btn btn-success"
                style={{ marginTop: "30px" }}
              >
                ออกรายงาน
              </Button>
            </Col>
          </Row>
        </Form>
        <hr></hr>
        <Row>
          <Col md="12">
            <div className="table-responsive">
              <table className="table mb-0">
                <thead className="thead-dark">
                  <tr>
                    <th className="mw200" scope="col">
                      รายงาน
                    </th>
                    <th className="mw200" scope="col">
                      ผู้ออกรายงาน
                    </th>
                    <th className="mw160" scope="col">
                      วันที่รายงาน
                    </th>
                    <th className="mw100" scope="col">
                      วันที่ออกรายงาน
                    </th>
                    <th className="mw100" scope="col">
                      เครื่องมือ
                    </th>
                  </tr>
                </thead>
                <tbody className="table-middle">
                  {dateReportList != null && dateReportList.data.length > 0 ? (
                    dateReportList.data.map((item, key) => {
                      return (
                        <tr key={item.reportSystemDataId}>
                          <td>{getreportSystemName(item.reportSystemId)}</td>
                          <td>
                            {item.firstName} {item.lastName}
                          </td>
                          <td>{item.dateRange}</td>
                          <td>{formatDate(item.lastUpdate)}</td>
                          <td>{getDownLoadReport(item)}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={5}>ยังไม่มีรายการรายงาน</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Col>
          <Col md="12" style={{ textAlign: "right" }}>
            {dateReportList != null && (
              <ReactPaginate
                pageCount={totalPage}
                forcePage={pageNumber - 1}
                containerClassName="pagination"
                nextLabel=">"
                previousLabel="<"
                onPageChange={({ selected }) => {
                  nextPage(selected, totalPage);
                }}
              />
            )}
          </Col>
        </Row>
      </Layout>
    </>
  );
};

export default AdminReport;
